import styled from 'styled-components';
export const StyledDownloadDataButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  width: 3.2rem;
  height: 3.2rem;

  border-radius: 5px;

  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.accent3)};

  background-color: ${(props) => props.theme.button2};

  @media screen and (min-width: 768px) {
    width: 4.1rem;
    height: auto;
  }

  @media screen and (min-width: 1024px) {
    padding: 1rem;
    padding: 0.7rem 2rem;
    padding-left: 1.5rem;
    min-width: fit-content;
  }

  .icon {
    width: 2rem;
    height: 2rem;

    @media screen and (min-width: 768px) {
      width: 2.4rem;
      height: 2.4rem;
    }

    @media screen and (min-width: 1024px) {
      width: 2rem;
      height: 2rem;
    }

    *[fill] {
      fill: currentColor;
    }
  }

  .title {
    display: none;
    @media screen and (min-width: 1024px) {
      display: inline;
    }
  }

  &:hover {
    background-color: ${(props) =>
      props.theme.id === 'dark' ? props.theme.accent1 : props.theme.button1};
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.text2)};
  }
`;
